























import { reactive, defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { DropdownFilter } from '@/models/filters/Filters';
import _ from 'lodash';
import { getDefaultFilterObject } from '@/utils/constants';

interface State {
  items: any[];
  loading: boolean;
}

interface Props {
  storePath: string;
  filterDropdown: DropdownFilter;
}

const Component = defineComponent({
  name: 'FilterBar',

  props: {
    storePath: String,
    filterDropdown: Object,
  },

  setup(props: Props) {
    const store: Store<RootState> = useStore();
    const items: any[] = [];
    const moduleName = props.filterDropdown.itemsModuleName;
    store.dispatch(`${moduleName}/setCustomSearchField`, undefined);
    if (moduleName)
      store.dispatch(`${moduleName}/fetchCustomFilteredItems`, { startFromPage: 1 });
    //used to track if new data fetch from request
    let isAllItems: boolean = false;
    let allItems: any[];

    const state: State = reactive({
      items: computed(() => {
        const newItems = store.getters[`${moduleName}/customFilteredItems`];

        if (newItems?.length == 0 && allItems !== undefined) isAllItems = true;
        else if (allItems === undefined)
          allItems = props.filterDropdown.hasDefaultValue
            ? [getDefaultFilterObject(props.filterDropdown)]
            : [];
        if (newItems) allItems = [...allItems, ...newItems];
        return allItems;
      }),
      loading: computed(() => store.getters[`${moduleName}/customLoading`]),
    });

    function filter(value: any) {
      store.dispatch(`${props.storePath}/setQueryFiltering`, {
        filterValue: value,
        filterBy: value ? props.filterDropdown.filterType : undefined,
      });
    }

    function cancelFilter() {
      store.dispatch(`${props.storePath}/setQueryFiltering`, null);
    }

    const updateItemsList = _.debounce((event: any) => {
      if (moduleName) {
        store.dispatch(`${moduleName}/setCustomSearchField`, {
          headers: [props.filterDropdown.textPropName],
          value: event?.target.value,
        });
        store.dispatch(`${moduleName}/fetchCustomFilteredItems`);
      }
    }, 200);

    function endIntersect(entries: any, observer: any, isIntersecting: any) {
      //stop send requests if all items fetched
      if (isIntersecting && moduleName && !isAllItems) {
        store.dispatch(`${moduleName}/setCustomFiltersNextPage`);
        store.dispatch(`${moduleName}/fetchCustomFilteredItems`);
      }
    }

    return {
      state,
      items,
      filter,
      cancelFilter,
      endIntersect,
      updateItemsList,
    };
  },
});

export default Component;
